import { render } from "./crm-id.vue?vue&type=template&id=52378281&ts=true"
import script from "./crm-id.ts?vue&type=script&lang=ts&external"
export * from "./crm-id.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__